<template>
  <div id="app">
    <div class="container">
      <ControlPane
        v-on:showAnswerForm="shownAnswerForm = true"
        v-on:showRatingTable="shownRatingTable = true"
        v-on:toggleVolume="toggleVolume"
        v-on:toggleFullScreen="toggleFullScreen"
        v-bind:allowedAnswerForm="allowedAnswerForm"
        v-bind:allowedRatingTable="allowedRatingTable"
        v-bind:isFullscreenMode="isFullscreenMode"
        v-bind:volumeOn="volumeOn"
        v-bind:hideable="isPresentation"
      />

      <Frame
        v-bind:frame="frameObj"
        v-on:sendForm="sendForm"
        v-on:frameEvent="frameEventHandler"
      />

      <RatingTable
        v-if="shownRatingTable"
        v-bind:gameId="gameId"
        v-on:close="shownRatingTable = false"
      />

      <AnswerForm
        v-bind:class="{ visible: shownAnswerForm }"
        v-bind:isFullscreenMode="isFullscreenMode"
        v-bind:frame="frameObj"
        v-bind:gameId="gameId"
        v-bind:key="frameObj.roundNumber"
        v-bind:isLoading="isFormSendPending"
        v-bind:sentAnswers="isFormSent"
        v-on:sendAnswers="sendAnswers"
        v-on:close="shownAnswerForm = false"
        ref="answerForm"
      />

      <sektor-timer
        class="main-frame__timer"
      />

      <!-- <Countdown
        ref="countdown"
        v-show="isCountdownVisible"
      /> -->
    </div>

    <!-- <VerticalScreenWarn /> -->
  </div>
</template>

<script>
/* global window document */

// import VerticalScreenWarn from './components/VerticalScreenWarn.vue';
import ControlPane from './components/ControlPane.vue';
import AnswerForm from './components/AnswerForm.vue';
import RatingTable from './components/RatingTable';
import Frame from './components/Frame';

// import Countdown from './components/Countdown.vue';

import * as AppSound from './state/AppSound';

import Api from './lib/PlayerApi';
import Auth from './lib/Auth';
import WSBus from './lib/WSocket';
import Toast from './lib/ToastWrapper';
import Storage from './lib/Storage';
import { mutations as exitMutations } from './lib/ExitBlocker';
// import GameInfo from './lib/GameInfo';
import { toggleFullScreen, isFullScreen } from './lib/FullScreen';
import FrameModel from './lib/FrameModel';
import * as FramesList from './lib/FramesList';

import { getWsBusUrl } from './lib/helpers';
import { timerMutations as Timer, SektorTimer } from './components/shared/Sektor';

const getVisibilityEventName = () => {
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange';
  }

  return visibilityChange;
};

export default {
  name: 'app',

  components: {
    // VerticalScreenWarn,
    ControlPane,
    Frame,
    AnswerForm,
    RatingTable,

    SektorTimer,
  },

  data() {
    return {
      shownAnswerForm: false,
      shownRatingTable: false,

      disableAnswerForm: false,

      isFormSendPending: false,
      isFormSent: false,

      wsBus: null,
      // frameData: LoadingFrame,
      frameObj: FramesList.GameIsLoading,

      isFullscreenMode: false,
      gameId: null,
      pincode: null,

      isCaptain: false,

      onlineStatus: 'online',
      isPresentation: false,

      isCountdownVisible: false,

      timeDelta: 0,
    };
  },

  computed: {
    allowedAnswerForm() {
      const isQuestion = this.frameObj && (
        this.frameObj.rawType === 'ft_question' || this.frameObj.rawType === 'ft_cutscene'
      );
      return !this.shownAnswerForm && !this.disableAnswerForm && isQuestion && this.isCaptain;
    },

    allowedRatingTable() {
      return !!this.gameId;
    },

    // TODO refactor
    volumeOn() {
      return AppSound.getters.isSoundOn();
    },
  },

  beforeDestroy() {
    if (this.wsBus) {
      this.wsBus.close();
    }

    document.removeEventListener('fullscreenchange', this.checkFullScreen);
    window.removeEventListener('online', this.checkOnline);
    window.removeEventListener('offline', this.checkOnline);

    Timer.stop();
  },

  mounted() {
    // window.addEventListener('beforeunload', (event) => {
    //   // eslint-disable-next-line no-param-reassign
    //   event.returnValue = 'В случае продолжения прогресс может быть утерян';
    // });

    window.addEventListener('online', this.checkOnline, false);
    window.addEventListener('offline', this.checkOnline, false);

    document.documentElement.className = window.navigator.onLine
      ? 'js-online' : 'js-offline';

    this.isFullscreenMode = isFullScreen();
    document.addEventListener('fullscreenchange', this.checkFullScreen);

    document.addEventListener(getVisibilityEventName(), this.handleVisibility, false);

    setTimeout(() => {
      const token = Auth.getAuth();

      if (token) {
        this.frameObj = FramesList.TeamSignIn;
      } else {
        this.frameObj = FramesList.Authenticate;
      }

      // this.frameObj = FramesList.PincodeRequest;
    }, 1e3);

    // check if presentation-mode
    if (window.location.search.length > 2) {
      this.isPresentation = window.location.search.slice(1)
        .split('&')
        .findIndex(x => /^presentation\b/.test(x)) >= 0;
    }

    // setTimeout(() => {
    //   this.frameData = PreviewFrame;

    //   Api.getGameInfo(this.gameId)
    //     .then(() => console.log('OK'))
    //     .catch((err) => {
    //       console.log(ERRORS);
    //       console.warn('Failed to fetch game info', err.message);
    //     });
    // }, 3e3);

    this.wsBus = new WSBus(getWsBusUrl());
    this.wsBus.onEvent(this.onMessage);
  },

  methods: {
    handleVisibility() {
      const hidden = window.document.hidden
        || window.document.msHidden
        || window.document.webkitHidden;

      // Toast.show('Check visibility');

      // console.log('hidden -> ', hidden);

      if (!hidden) {
        // console.log('will ping from visiblity');
        this.sendPing();
      }

      // if (!hidden) {
      //   // will check connection
      //   this.onlineStatus = 'pending';
      //   try {
      //     this.wsBus.sendMessage({ event: 'status' });
      //   } catch {
      //     // skip
      //   }

      //   setTimeout(() => {
      //     console.log('Status -> ', this.onlineStatus);
      //     if (this.onlineStatus !== 'online') {
      //       this.reconnectToGame();
      //     }
      //   }, 2e3);
      // }
    },

    checkOnline() {
      if (!('onLine' in window.navigator)) return;

      document.documentElement.className = document.documentElement.className
        .replace(/(js-online|js-offline)/, window.navigator.onLine ? 'js-online' : 'js-offline');

      // console.log('We are -> %s', window.navigator.onLine ? 'online' : 'offline');

      // Toast.show('check online');

      if (window.navigator.onLine) {
        // console.log('will ping from online');
        this.sendPing();
      }
    },

    sendPing() {
      // Toast.show('Send ping');
      this.onlineStatus = 'pending';
      this.wsBus.sendMessage({ event: 'status' });

      setTimeout(() => {
        if (this.onlineStatus !== 'online') {
          this.sendPing();
        }
      }, 5e3);
    },

    reconnectToGame() {
      console.warn('Should reconnect to game');
      this.wsBus.reconnect();
      // this.onlineStatus = 'offline';
      // this.wsBus.close();
      // this.wsBus.reconnectToGame({ code: this.pincode });
    },

    /**
     * possible events
     *  connection_error
     *  game_attached
     *  update_frame
     */
    onMessage(e) {
      console.log('Msg from WSocket', e);
      this.onlineStatus = 'online';

      switch (e.event) {
        case 'connection_error':
          exitMutations.stopPrevent();

          // Toast.show('Подключиться не удалось');

          if (this.frameObj.rawType === 'loading') {
            // window.location.reload(); // try to reload page
          }
          break;

        case 'update_frame':
          // stop and hide countdown
          Timer.stop();
          // this.isCountdownVisible = false;

          if (e.timestamp) {
            this.timeDelta = Math.round(Date.now() / 1000) - e.timestamp;
            console.log('new-delta -> ', this.timeDelta);
          }

          this.updateCurrentFrame(e.frame);
          break;

        case 'game_attached':
          exitMutations.setPrevent();

          if (e.timestamp) {
            this.timeDelta = Math.round(Date.now() / 1000) - e.timestamp;
          }

          this.gameId = e.game_selector;

          if (e.current_frame) {
            setTimeout(() => this.updateCurrentFrame(e.current_frame), 1e3);
          } else {
            this.frameObj = FramesList.PleaseWait;
          }

          if (e.current_timer) {
            // this.isCountdownVisible = true;
            // max(0, value) -- means we will value if value is above 0 and 0 otherwise

            Timer.start({
              timeout: e.current_timer.countdown,
              timePassed: e.current_timer.countdown - Math.max(0, (
                e.current_timer.countdown
                  - (Math.round(Date.now() / 1000) - this.timeDelta)
                  + e.current_timer.timestamp
              )),
            });
          }

          if (e.options) {
            if ('allow_input' in e.options) {
              this.disableAnswerForm = !e.options.allow_input;

              if (this.disableAnswerForm) {
                this.shownAnswerForm = false;
              }
            }

            if ('show_ratings' in e.options) {
              this.shownRatingTable = e.options.show_ratings;
            }
          }
          break;

        case 'error':
          // console.log('Error from socket', e);
          this.frameObj = FramesList.GameNotFound;
          break;

        case 'update_game_options':
          // console.warn('update options', e);
          if ('allow_input' in e.options) {
            this.disableAnswerForm = !e.options.allow_input;

            if (this.disableAnswerForm) {
              if (this.$refs.answerForm && this.isCaptain) {
                this.$refs.answerForm.sendForm();
                Toast.show('Ваши ответы сохранены');
              }

              this.shownAnswerForm = false;
            }
          }

          if ('show_ratings' in e.options) {
            // console.warn('SHOW RATING', e.options.show_ratings);
            this.shownRatingTable = e.options.show_ratings;
          }
          break;

        case 'update_game':
          console.error('Update-Game event not handled', e);
          break;

        case 'start_timer':
          // this.isCountdownVisible = true;
          Timer.start({
            timeout: e.countdown,
            timePassed: e.countdown - Math.min(e.countdown, (
              e.countdown - (Math.round(Date.now() / 1000) - this.timeDelta) + e.timestamp
            )),
          });
          break;

        case 'stop_timer':
          // this.isCountdownVisible = false;
          Timer.stop();
          break;

        case 'status':
          this.onlineStatus = 'online';

          // Toast.show('status event handler');
          if (!this.pincode || !this.gameId) return;

          console.log('should connect to game');
          this.wsBus.connectToGame({ code: this.pincode });
          break;

        default:
          console.warn('Unknown event type', e.event);
          break;
      }
    },

    // handleCountdown(action) {
    //   this.$refs.countdown[action]();
    // },

    updateCurrentFrame(frame) {
      this.frameObj = new FrameModel(frame);
    },

    toggleFullScreen() {
      toggleFullScreen();
    },

    toggleVolume() {
      AppSound.mutations.toggleSound();
    },

    checkFullScreen() {
      this.isFullscreenMode = isFullScreen();
    },

    sendForm(formData) {
      console.log('Got form', formData);

      if (formData.action === 'pincode') {
        this.frameObj = FramesList.GameIsLoading;

        this.pincode = formData.pincode;

        setTimeout(() => {
          this.wsBus.connectToGame({ code: this.pincode })
            .catch((err) => {
              console.log('Failed to connect', err);
              window.location.reload();
            });

          this.frameObj = FramesList.GameIsLoading;

          // if (this.isCaptain) {
          //   this.frameObj = FramesList.TeamSignIn;
          // } else {
          //   this.wsBus.connectToGame({ code: this.pincode })
          //     .catch((err) => {
          //       console.log('Failed to connect', err);
          //       window.location.reload();
          //     });

          //   this.frameObj = FramesList.GameIsLoading;
          // }
        }, 1e3);

        // this.isCaptain = formData.captain;

        // Api.getGameByCode(formData.pincode)
        //   .then(({ game }) => {
        //     if (!game) {
        //       throw new Error('Bad game selector');
        //     }

        //     this.frameObj = FramesList.PleaseWait;

        //     this.gameId = game;

        //     // should ask for team and city
        //     this.wsBus.connectToGame({ game, code: formData.pincode });
        //   })
        //   .catch((err) => {
        //     console.warn('Failed to get game by pincode', err);
        //     this.frameObj = FramesList.GameNotFound;
        //   });
      } else if (formData.action === 'signin') {
        const {
          teamName,
          teamCity,
          teamSelector,
          isCaptain,
        } = formData;

        this.isCaptain = isCaptain;
        Storage.set('player', JSON.stringify({ teamName, teamCity, teamSelector }));
        this.frameObj = FramesList.PincodeRequest;

        // this.wsBus.connectToGame({ code: this.pincode })
        //   .catch((err) => {
        //     console.log('Failed to connect', err);
        //     window.location.reload();
        //   });

        // this.frameObj = FramesList.GameIsLoading;

        // Api.getGameByCode(formData.pincode)
        //   .then(({ game }) => {
        //     if (!game) {
        //       throw new Error('Bad game selector');
        //     }

        //     this.frameObj = FramesList.PleaseWait;

        //     this.gameId = game;

        //     // should ask for team and city
        //     this.wsBus.connectToGame({ code: this.pincode });
        //   })
        //   .catch((err) => {
        //     console.warn('Failed to get game by pincode', err);
        //     this.frameObj = FramesList.GameNotFound;
        //   });
      } else {
        console.log('Unknown form', formData);
      }
    },

    sendAnswers(formData) {
      let teamInfo;

      try {
        const raw = Storage.get('player');
        teamInfo = JSON.parse(raw);
        if (!teamInfo.teamSelector) throw new Error('Empty team selector');
      } catch {
        Toast.show('Ошибка при отправке ответов - отсутствует название команды');
        return;
      }

      const data = {
        // team_name: teamInfo.teamName,
        team_selector: teamInfo.teamSelector,
        city: teamInfo.teamCity,
        game_part_selector: this.gameId,
        round_selector: this.frameObj.roundSelector,
        answers: Object.keys(formData.answers).map(key => ({
          question_number: key,
          answer: formData.answers[key],
          data: {
            xx: formData.xx[key],
            bet: formData.bet[key],
          },
        })),
      };

      this.isFormSendPending = true;

      Api.sendAnswers(data)
        .then(() => {
          this.isFormSent = true;
        })
        .catch(err => console.warn('Failed to send answers', err))
        .then(() => {
          Toast.show('Ответы отправлены');

          this.isFormSendPending = false;

          setTimeout(() => {
            this.shownAnswerForm = false;
          }, 500);

          setTimeout(() => {
            this.isFormSent = false;
          }, 2000);
        });
    },

    frameEventHandler({ event, data }) {
      console.log('New event', event, 'with', data);

      if (event === 'auth-success') {
        this.frameObj = FramesList.TeamSignIn;
      }

      if (event === 'switch-to-pincode') {
        this.frameObj = FramesList.PincodeRequest;
      }
    },
  },
};
</script>

<!-- <style lang="less" src="./assets/less/app.less"></style> -->
<style lang="scss" src="./assets/scss/app.scss"></style>
<style lang="less" src="./assets/less/icons2.less"></style>
